import { QRCodeSVG } from "qrcode.react";
import { useRouter } from "next/router";
import Icon from "@Components/ui/icon";
import { KIOSK_VIEW_MODE_QUERY } from "@Constants/url";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { IHeader } from "@Types/recipes-detail-page";
import { whereAmI } from "@Utils/whereAmI";
import { Carousel } from "./Carousel";
import classes from "./RecipesDetail.module.scss";
import "react-slideshow-image/dist/styles.css";

interface HeaderProps extends IHeader {}

export const Header = (props: HeaderProps) => {
  const {
    query: { viewMode },
  } = useRouter();
  const [linkWithoutViewModeQuery] = whereAmI().split("?viewMode");

  const imageList = props.imageList?.items || props.recipeBanner || [];

  return (
    <div className={classes["main-content"]}>
      <div className={classes["main-content__header"]}>
        <h1>
          <span>{props["recipe.page.title"]}</span>
          {props.title}
        </h1>

        <ul className={classes["list"]}>
          <li>
            <Icon className={classes["icon"]} iconName="clock" />
            {props["recipe.page.prepTime"]} {props.prepTime}
          </li>
          <li>
            <Icon className={classes["icon"]} iconName="clock" />
            {props["recipe.page.cookTime"]} {props.cookTime}
          </li>
        </ul>

        {viewMode === KIOSK_VIEW_MODE_QUERY && (
          <QRCodeSVG value={linkWithoutViewModeQuery} />
        )}

        <CmsTextEditorContent content={props.description} />
      </div>
      <div className={classes["main-content__gallery"]}>
        <Carousel imageList={imageList} />
      </div>
    </div>
  );
};
